import { db, fb } from './firebase';

export const getAlerts = async () => {
  const userID = fb.auth().currentUser.uid;
  const alertsRef = await db
    .collection('users').doc(userID)
    .collection('alerts')
    .get();
    const alerts = alertsRef.docs.map((alert) => {
      return { id: alert.id, ...alert.data() };
    });
    return alerts;
}

export const sendSignUpAlert = async (user) => {
  const { firstName, lastName, email, hall: hallID, id } = user;
  const alert = {
    type: 'alert/signup',
    user: id,
    firstName,
    lastName,
    email,
  };
  const hallRef = await db
    .collection('halls').doc(hallID)
    .get();
  const admins = hallRef.get('administrators');
  for (let i = 0; i < admins.length; i++) {
    const admin = admins[i];
    await db
      .collection('users').doc(admin)
      .collection('alerts')
      .add(alert)
  }
}

export const removeAlert = async (alertID) => {
  const userID = fb.auth().currentUser.uid;
  await db
    .collection('users').doc(userID)
    .collection('alerts').doc(alertID)
    .delete();
}

export const handleSignUpAccept = async (userID, alertID) => {
  await db
    .collection('users').doc(userID)
    .update({ isPending: false, isAccepted: true });
  await removeAlert(alertID);
}

export const handleSignUpDecline = async (userID, alertID) => {
  await db
    .collection('users').doc(userID)
    .update({ isPending: false, isAccepted: false });
  await removeAlert(alertID);
}